import React, { Suspense } from 'react'
import { Grid } from '@material-ui/core'
import './styles/viewFormsDraft.scss'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import 'react-datepicker/dist/react-datepicker.css'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import TableFormularios from './TableFormularios'

const ViewFormsElegibilidad = () => {
  const history = useHistory()
  const cancelForm = () => {
    history.push('/')
  }

  return (
    <Grid
      container
      style={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          height: 'auto',
          width: '96%',
          backgroundColor: '#fff',
          borderRadius: '4px',
          marginTop: '10px',
        }}
      >
        <Grid md={12} sm={12}>
          <div className="tableTitle">
            <Grid item md={12} xs={12} style={{ padding: '20px' }}>
              <h1
                style={{
                  fontSize: '30px',
                  fontWeight: '900',
                  color: '#111',
                }}
              >
                Eliminar Representación
              </h1>
              <Grid
                container
                spacing={1}
                style={{ paddingRight: '2%' }}
                justifyContent="flex-end"
              >
                <div
                  data-tip
                  data-for="exitPop"
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'right',
                    align: 'flex-end',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                    position: 'absolute',
                  }}
                  onClick={() => cancelForm()}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>
              <p
                style={{
                  paddingLeft: '3px',
                  paddingTop: '5px',
                  marginTop: '1%',
                }}
              >
                Seleccione la IFI a dejar de representar
              </p>
            </Grid>
          </div>
        </Grid>
        <div style={{ padding: '20px' }}>
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '40vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <TableFormularios />
          </Suspense>
        </div>
      </div>
    </Grid>
  )
}
export default React.memo(ViewFormsElegibilidad)
